import { Helmet } from "react-helmet-async";
import services from "../data/services.json";
import details from "../data/details.json";

export default function ContactHelmet() {
  const serviceTitles = services.services
    .map((service) => service.title)
    .join(", ");

  return (
    <Helmet>
      <title>{"Επικοινωνία | " + details.sitetitle}</title>
      <meta
        name="description"
        content="Η Θεραπευτική γωνιά παιδιού & ενήλικα αποτελείται από εξειδικευμένους και ειδικά καταρτισμένους θεραπευτές που αναλαμβάνουν την πλήρη αξιολόγηση και θεραπευτική παρέμβαση παρέχοντας τις υπηρεσίες τους με αγάπη, σεβασμό και ενσυναίσθηση σε κάθε άτομο/οικογένεια."
      />
      <meta name="keywords" content={"Επικοινωνία, " + serviceTitles} />
      <meta
        property="og:title"
        content={"Επικοινωνία | " + details.sitetitle}
      />
      <meta
        property="og:description"
        content="Η Θεραπευτική γωνιά παιδιού & ενήλικα αποτελείται από εξειδικευμένους και ειδικά καταρτισμένους θεραπευτές που αναλαμβάνουν την πλήρη αξιολόγηση και θεραπευτική παρέμβαση παρέχοντας τις υπηρεσίες τους με αγάπη, σεβασμό και ενσυναίσθηση σε κάθε άτομο/οικογένεια."
      />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://therapycorner.gr/contact" />
    </Helmet>
  );
}
